<template>
  <div class="popup">
    <div class="popup-bg"></div>
    <div class="content">
      <div class="detail" v-html="detail"></div>
      <em class="close j-back" @click="close"></em>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detail'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
$termsImg: '~@assets/image/terms/';
.popup {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  &-bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 48px 30px;
    box-sizing: border-box;
    border-radius: 20px;
    width: 590px;
    height: 648px;
    background: #fff;
    transform: translate(-50%, -50%);
  }
  .detail {
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 100%;
    line-height: 40px;
    font-size: 24px;
    color: #414141;
    ::v-deep * {
      font-size: 24px;
      color: #414141;
    }
    ::v-deep .title {
      font-weight: bolder;
      font-size: 34px;
    }
    ::v-deep table {
      border-color: #77aee8 !important;
    }
    ::v-deep td {
      border-color: #77aee8 !important;
    }
    ::v-deep .td-title {
      background-color: #77aee8 !important;
      color: #fff !important;
    }
    ::v-deep .td-title-text {
      color: #fff !important;
    }
    ::v-deep span {
      word-break: break-all;
    }
  }
  .close {
    position: fixed;
    right: 21px;
    top: 21px;
    width: 41px;
    height: 27px;
    background: url($termsImg + 'back.png') no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) {
  .popup {
    .content {
      box-sizing: border-box;
      padding: 10px 30px;
      width: 85%;
      height: 263px;
      .detail {
        line-height: 30px;
        font-size: 14px;
        ::v-deep * {
          font-size: 14px;
        }
        ::v-deep .title {
          font-weight: bolder;
          font-size: 20px;
        }
      }
    }
    .close {
      right: 10px;
      top: 10px;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
